module.exports = __webpack_public_path__ + "static/beauty-our-portfolio-section-code-0947491334e8f015a20cc7e28e17fb27.png";